import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class FormattingService {

	constructor() { }

	static formatFileSize(size: number): string {
		// Spec:
		// If value >= 1000000, show "n.m MB"
		// If 1000000 > value >= 1000 show "n.m KB"
		// Else show "n B"

		if (size >= 1000000) {
			return `${(size / 1000000).toLocaleString(undefined, { maximumFractionDigits: 2 })} MB`;
		}
		else if (1000000 > size && size >= 1000) {
			return `${(size / 1000).toLocaleString(undefined, { maximumFractionDigits: 2 })} KB`;
		}
		else {
			return `${size} B`;
		}
	}
}
